export default "__VITE_ASSET__DW0kckWo__"